import { render, staticRenderFns } from "./RegisterMobilephone.vue?vue&type=template&id=8490e58c&scoped=true"
import script from "./RegisterMobilephone.vue?vue&type=script&lang=js"
export * from "./RegisterMobilephone.vue?vue&type=script&lang=js"
import style0 from "./RegisterMobilephone.vue?vue&type=style&index=0&id=8490e58c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8490e58c",
  null
  
)

export default component.exports